import { useEffect, useState } from 'react';
import { urlFor } from "@/sanity/lib/image";
import dynamic from "next/dynamic";
const Swiper = dynamic(() => import('swiper/react').then(mod => mod.Swiper), { ssr: false });
import { SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import styles from "./blogSlider.module.scss";
import Button from "@/components/Button";
import Link from "next/link";

import ArrowRight from "/packages/icons/arrow-right.svg";
import ArrowLeft from "/packages/icons/arrow-left.svg";
import BrandsIcon from "/packages/icons/category/brands.svg";
import BlogCard from "../../blog/BlogCard";

import { sanityClient } from '@/sanity/lib/client';
import { BLOG_SLIDER_POSTS_QUERY } from '@/sanity/lib/queries';

export default function BlogSlider({ title = 'Blogs', posts = [], viewAllLink = '/blog' }) {  

  const [blogPosts, setBlogPosts] = useState(posts);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!posts?.length && !hasFetched) {
      sanityClient.fetch(BLOG_SLIDER_POSTS_QUERY)
        .then((data) => {
          setBlogPosts(data);
          setHasFetched(true);
        })
        .catch(console.error);
    }
  }, [posts, hasFetched]);

  const swiperConfig = {
    modules: [Navigation],
    className: styles.blogSlider,
    touchEventsTarget: "wrapper",
    breakpoints: {
      1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 16 },
      768: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 14 },
      550: { slidesPerView: 1.2, slidesPerGroup: 1, spaceBetween: 10 },
      0: { slidesPerView: 1.2, slidesPerGroup: 1, spaceBetween: 10 },
    },
    navigation: {
      prevEl: `#blog-prev`,
      nextEl: `#blog-next`,
      clickable: true,
    },
  };

  return (
    <div className={`${styles.container} blog-slider`}>
      <div className={styles.header}>
        <div className={styles.header__content}>
          <div className={styles.title}>
            <h2>{title}</h2>
          </div>
        </div>
        <Button
          type="link"
          href={viewAllLink}
          className="sliderLink"
          prefetch={false}
          ariaLabel="View All Brands"
        >
          <span>view all</span>
        </Button>
      </div>

      <Swiper {...swiperConfig}>
        <div className={styles.prev} id="blog-prev">
          <Button type="button" className="slider-arrow" ariaLabel="Previous Slide">
            <ArrowLeft />
          </Button>
        </div>
        <div className={styles.next} id="blog-next">
          <Button type="button" className="slider-arrow" ariaLabel="Next Slide">
            <ArrowRight />
          </Button>
        </div>

        {blogPosts.map((post) => {
          return (
            <SwiperSlide key={post._id} className={styles.slide}>
              <BlogCard
                key={post._id}
                image={urlFor(post.mainImage).width(454).height(227).url()}
                title={post.title}
                url={post?.slug.current}
                showArrow
              />
            </SwiperSlide>
          );
        })}

        <SwiperSlide className={styles.lastSlide}>
          <Link href={viewAllLink}>
            <div className={styles.icon}>
              <BrandsIcon />
            </div>
            View All
          </Link>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}